import React, { forwardRef, useState } from 'react';
import MultiFeatureCard from '../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import MultiMetricTable from './MultipleMetricTable';
import { View } from '../../../../../components/Common/react-native-components';
import { get } from 'lodash';

const SegmentRanker = forwardRef((props, ref) => {
  const { itemData, timeperiodLabel, applied_filter_values, reduxData } = props;
  const [activeSwitch, setActiveSwitch] = useState();

  function renderContent() {
    const widgetId = get(itemData, ['widgetIdMap', activeSwitch], 'ai_analytics_segment_ranker_metrics');
    switch (activeSwitch) {
      case 'TIME':
        return (
          <>
            <MultiMetricTable
              key={widgetId}
              itemData={itemData?.[widgetId]}
              applied_filter_values={applied_filter_values}
              widgetId={widgetId}
              reduxData={reduxData}
              hasNestedData={false}
            />
          </>
        );
      case 'TABLE':
        return (
          <>
            <MultiMetricTable
              key={widgetId}
              itemData={itemData?.[widgetId]}
              applied_filter_values={applied_filter_values}
              widgetId={widgetId}
              reduxData={reduxData}
              hasNestedData={false}
            />
          </>
        );
    }
  }

  return (
    <MultiFeatureCard
      title={'Segment Ranker'}
      subTitle={`Time Period: ${timeperiodLabel}`}
      style={{ childContainer: { paddingVertical: 20 } }}
      enableSwitchTab={itemData?.enableSwitchTab}
      switchOptions={itemData?.switchOptions}
      renderContent={(activeSwitch, contentRef) => {
        setActiveSwitch(activeSwitch);
        return <View>{renderContent()}</View>;
      }}
    />
  );
});

export default SegmentRanker;
